export const WYSIWYG_EDITOR_INITIAL_VALUE_UI_KEY_PATH = [
  'wysiwyg',
  'initialValue',
];
export const WYSIWYG_EDITOR_VALUE_UI_KEY_PATH = ['wysiwyg', 'value'];
export const WYSIWYG_EDITOR_FOCUSED_UI_KEY_PATH = ['wysiwyg', 'focused'];

export const WYSIWYG_EDITOR_DEBOUNCE_WAIT = 700;
